import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'VersionesGias';

export interface VersionGias {
  idVersion: number;
  fechaAlta: string;
  descCorta: string;
  descripcion: string;
  año: number;
  principal: boolean;
}

export interface VersionGiasAño {
	idVersion: number;
	año: number;
}

export class VersionesGiasAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarVersionesGias(soloPrincipales?:boolean): AxiosPromise<VersionGias[]> {
		return this.cliente.get(`/ListarVersionesGias?soloPrincipales=${soloPrincipales}`);
	}

	VersionGias(año:number): AxiosPromise<VersionGiasAño[]> {
		return this.cliente.get(`/VersionGias/${año}`);
	}
}